module.exports = __webpack_public_path__ + "img/achievement_1.1471b01a.png";